import React from 'react';
import Skeleton from "@material-ui/lab/Skeleton";
import {Paper } from '@material-ui/core';
import { useSubPanelStyles } from '../styles/muiStyles';
import Avatar from '@material-ui/core/Avatar';
import SkeletonCard from './SkeletonCard';







const SkeletonSmall = () => {
const classes = useSubPanelStyles();



  return (
    <div>

        


     <Paper variant="outlined" style={{marginLeft:8 , marginRight:8 , marginTop:8 , paddingBottom:30}} className={classes.listPaper}>

     <div>
     <Skeleton variant="circle" height={60} width={60}  style={{ marginLeft: 130 , marginTop: 10 }}  >
              <Avatar />
            </Skeleton>  
            <Skeleton animation="wave" height={10} width={100} style={{ marginTop: 6 ,  marginLeft: 110 }} />

            </div>


     <div style={{ display:'flex' , flexDirection:'' , alignItems:'' , justifyContent:'space-around' }}>

            <div Style={{ display:'flex' , flexDirection:'row' , alignItems:'' }} > 
     <Skeleton animation="wave" height={10} width={100} style={{ marginLeft: 40 , marginTop: 20 }} />
     <Skeleton animation="wave" height={10} width={150} style={{ marginLeft: 20 , marginTop: 15 ,  marginBottom: 30  }} />
     <Skeleton animation="wave" height={10} width={80} style={{ marginLeft: 45 , marginTop: 15 }} />
     <Skeleton animation="wave" height={10} width={130} style={{ marginLeft: 20 , marginTop: 15 }} />

     </div>

     <div Style={{ display:'flex' , flexDirection:'row' , alignItems:'' }} > 
     <Skeleton animation="wave" height={10} width={100} style={{ marginLeft: 30 , marginTop: 20 }} />
     <Skeleton animation="wave" height={10} width={40} style={{ marginLeft: 55 , marginTop: 15 ,  marginBottom: 30 }} />
     <Skeleton animation="wave" height={10} width={80} style={{ marginLeft: 25 , marginTop: 15  }} />
     <Skeleton animation="wave" height={10} width={130} style={{ marginLeft: 5 , marginTop: 15 }} />

     </div>
     </div>



      </Paper>
      <div style={{ marginBottom: 27 }}> </div>
      <SkeletonCard />

    </div>
  );
};


export default SkeletonSmall;